import React, { useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useParams } from "react-router-dom"
import { Tooltip, Row, Col, Form, Switch, Select, DatePicker, Button } from "antd"
import { Link, useRouteMatch } from "react-router-dom"
import path from "path"
import { fetchAssociatedClientBatches, fetchClientNames, generateBillSummaryReport, selectAssociatedBatches, selectClientNames, selectLoading, setLoading } from "./adminReportsSlice"
import requestNotification from "../../../lib/notifications"

export default function AdminReportDashboard() {
    const { url } = useRouteMatch()

    const dispatch = useDispatch()

    const clients = useSelector(selectClientNames)
    const loading = useSelector(selectLoading)
    const clientBatches = useSelector(selectAssociatedBatches)

    const [init, setInit] = useState(false)
    const [form] = Form.useForm()

    const focusInput = useRef(null)

    const [selectedDateRange, setSelectedDateRange] = useState(false)
    const [selectedClientBatches, setSelectedClientBatches] = useState(false)
    const [groupCheck, setGroupCheck] = useState(false)
    const [countingCheck, setCountingCheck] = useState(false)

    useEffect(() => {
        if (init) {
            return
        }

        setInit(true)
        dispatch(fetchClientNames())
    }, [dispatch, init])

    const submit = async (values) => {
        values.date_range = values.date_range ?? []
        values.group_by = groupCheck ? "facility" : "division"
        values.counting = countingCheck ? "meter_numbers" : "billable_accounts"
        // console.log(values)
        await dispatch(generateBillSummaryReport(values))
            .then((response) => {
                if (response) response.blob()
            })
            .then((blob) => {
                if (blob) {
                    const url = window.URL.createObjectURL(blob)
                    const a = document.createElement("a")
                    a.href = url
                    a.download = `bill_summary_report_${Date.now()}.csv`
                    a.click()
                    window.URL.revokeObjectURL(url)
                }
            })
            .catch((e) => console.log("ERROR", e))

        // if (response.data.success) {
        //     history.push(backPath())
        // }

        // requestNotification(response.data)
    }

    // useEffect(()=>{},[])

    // console.log(form.getFieldValue("client"))

    return (
        <div id="user-form-container">
            {/* <Row gutter={24}>
                <Form form={form} initialValues={initialValues()} onFinish={submit} layout="vertical"> 
            </Row> */}
            <Form form={form} onFinish={submit} layout="vertical">
                <div className="card">
                    <div className="card-body" style={{ display: "block" }}>
                        <Row gutter={24}>
                            <Col span={24}>
                                <Form.Item label="Client" name="client" rules={[{ required: true, message: "Please select a client" }]}>
                                    <Select
                                        // mode="multiple"
                                        showSearch
                                        placeholder="Select Client"
                                        showArrow={true}
                                        filterOption={(input, option) => {
                                            const inputLower = input.toLowerCase()
                                            const value = option?.value ? option.value.toString().toLowerCase() : ""
                                            let label = ""
                                            if (typeof option?.children === "string") {
                                                label = option.children.toLowerCase()
                                            } else if (option?.children && option.children.props && option.children.props.children) {
                                                label = option.children.props.children.toString().toLowerCase()
                                            }
                                            return value.includes(inputLower) || label.includes(inputLower)
                                        }}
                                        onChange={(e) => {
                                            // console.log(e)
                                            // dispatch(setLoading(true))
                                            dispatch(fetchAssociatedClientBatches(e))
                                            if(e === 'All') setCountingCheck(true)
                                            // dispatch(setLoading(false))
                                        }}>
                                        {[{ identifier: "All", name: "All Clients" }, ...clients]?.map((o) => (
                                            <Select.Option key={o.identifier} value={o.identifier}>
                                                {o.name}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                        <hr />
                        <Row gutter={24}>
                            <Col span={12}>
                                <Form.Item
                                    label="Client Batch(es)"
                                    name="accounting_batches"
                                    dependencies={["date_range"]}
                                    rules={[
                                        {
                                            validator: (_, value) => {
                                                const other = form.getFieldValue("date_range")
                                                const hasThis = Array.isArray(value) && value.length > 0
                                                const hasOther = Array.isArray(other) && other.length === 2 && other[0] && other[1]

                                                if ((hasThis && hasOther) || (!hasThis && !hasOther)) {
                                                    return Promise.reject(new Error("Select either Client Batch OR Date Range."))
                                                }
                                                return Promise.resolve()
                                            },
                                        },
                                    ]}>
                                    <Select
                                        mode="multiple"
                                        showSearch
                                        placeholder="Select Batch(es)"
                                        showArrow={true}
                                        disabled={selectedDateRange || loading}
                                        onChange={(e) => {
                                            form.validateFields(["date_range"])
                                            setSelectedClientBatches(e.length > 0 ? true : false)
                                        }}>
                                        {clientBatches?.map((client_batch) => (
                                            <Select.Option key={client_batch.id} value={client_batch.id}>
                                                {client_batch.batch_code}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col span={12}>
                                <Form.Item
                                    label="Date Range"
                                    name="date_range"
                                    dependencies={["accounting_batches"]}
                                    rules={[
                                        {
                                            validator: (_, value) => {
                                                const other = form.getFieldValue("accounting_batches")
                                                const hasThis = Array.isArray(value) && value.length === 2 && value[0] && value[1]
                                                const hasOther = Array.isArray(other) && other.length > 0

                                                if ((hasThis && hasOther) || (!hasThis && !hasOther)) {
                                                    return Promise.reject(new Error("Select either Client Batch OR Date Range."))
                                                }
                                                return Promise.resolve()
                                            },
                                        },
                                    ]}>
                                    <DatePicker.RangePicker
                                        style={{ width: "100%" }}
                                        ref={focusInput}
                                        allowClear={true}
                                        allowEmpty={[true, true]}
                                        format={"MM/DD/YYYY"}
                                        disabled={selectedClientBatches}
                                        onChange={(e) => {
                                            form.validateFields(["accounting_batches"])
                                            setSelectedDateRange(e ? true : false)
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <hr />
                        <Row gutter={24}>
                            <Col span={24}>
                                <Form.Item label="Group By:" name="group_by">
                                    Division {"  "}
                                    <Switch checked={groupCheck} onChange={(e) => setGroupCheck(e)} />
                                    {"  "} Facility
                                </Form.Item>
                            </Col>
                        </Row>
                        <hr />
                        <Row gutter={24}>
                            <Col span={24}>
                                <Form.Item label="Items to count:" name="counting">
                                    {" "}
                                    {/* Should probably change to name something different */}
                                    Billable Accounts {"  "}
                                    <Switch checked={countingCheck || form.getFieldValue("client") == 'All'} onChange={(e) => setCountingCheck(e)}  disabled={form.getFieldValue("client") == 'All'}/>
                                    {"  "} Meter Numbers
                                </Form.Item>
                            </Col>
                        </Row>
                        <hr />
                        <Row gutter={24}>
                            <Col span={24}>
                                <Form.Item>
                                    <Button type="primary" htmlType="submit">
                                        Submit
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Row>
                    </div>
                </div>
            </Form>
        </div>
    )
}
